import useSWR from "swr";

type StampCard = {
  img: string;
}

export const useFetchStampCardByRestaurantId = (restaurantId: string) => {
  const { data: stampCard, error, isLoading } = useSWR<StampCard>(`membership/restaurants/${restaurantId}/stamp-card/`)
  return { stampCard, isLoading, error };
};